import {ModuleWithProviders, NgModule} from '@angular/core';

import {
  ExecutiveUsersSpec,
} from './';
import { AppAccessPermissionSpec } from './specs/app-access.spec';

const PROVIDERS = [
  AppAccessPermissionSpec,
  ExecutiveUsersSpec
];

@NgModule({
  providers: [
    ...PROVIDERS
  ],
})

export class SpecificationModule {
  static forRoot(): ModuleWithProviders<SpecificationModule> {
    return <ModuleWithProviders<SpecificationModule>>{
      ngModule: SpecificationModule,
      providers: [...PROVIDERS],
    };
  }
}
